<template>
  <CheckoutStep class="h-full">
    <template #header>
      <Stepper />
    </template>
    <template #aside>
      <GiftCardSummary
        v-if="giftCard"
        :asset-url="giftCard.designAsset.assetUrl"
        :price="giftCard.price"
      />
    </template>

    <div aria-live="polite" role="status">
      <BillingAddress :billing-address @update="handleUpdate" />
    </div>
  </CheckoutStep>
</template>

<script setup lang="ts">
import { navigateTo } from '#imports'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

import type { Bill } from '~/api/cart/types'
import CheckoutStep from '~/scopes/checkout/components/CheckoutStep/CheckoutStep.vue'
import { CHECKOUT } from '~/scopes/checkout/routes-names'

import GiftCardSummary from '../../components/GiftCardSummary/GiftCardSummary.vue'
import Stepper from '../../components/Stepper/Stepper.vue'

import BillingAddress from './components/BillingAddress/BillingAddress.vue'

defineProps<{
  giftCard: ApiSpecs['/api/gift-cards/v1/product-page/giftcard/request/:requestId']['GET']['response']
  billingAddress: Bill
}>()

const emit = defineEmits<{
  (e: 'update', callback: () => void): void
}>()

function handleUpdate() {
  emit('update', () => {
    navigateTo({ name: CHECKOUT.GIFT_CARDS.PAYMENT })
  })
}
</script>
